export default function UserCell({
  user,
  showEmail = true,
  showCid = true,
  className = "",
}) {
  if (!user) {
    return <span className="italic text-text opacity-40">N/A</span>;
  }

  const fullName = user.name
    ? `${user.name.first || ""} ${user.name.last || ""}`.trim()
    : user.fullName || "Unknown User";

  return (
    <div className={className}>
      <div className="font-medium text-text">{fullName}</div>
      {showEmail && user.email && (
        <div className="text-xs text-text opacity-60">{user.email}</div>
      )}
      {showCid && user.cid && (
        <div className="text-xs text-text opacity-60">CID: {user.cid}</div>
      )}
    </div>
  );
}
